import IMask from 'imask'
import {DirectiveOptions} from 'vue'

export const iMaskDirective: DirectiveOptions = {
  bind(el: any, {value: options}) {
    if(!options) {return}
    if(!el.value) {
      el.value = ''
    }
    initMask(el, options)
  },

  update(el: any, {value: options}) {
    if(options) {
      if(el.maskRef) {
        el.maskRef.updateOptions(options)
      }
      else {initMask(el, options)}
    } else {
      destroyMask(el)
    }
  },

  unbind(el) {
    destroyMask(el)
  },
}

function fireEvent(el, eventName, data) {
  const event = document.createEvent('CustomEvent')
  event.initCustomEvent(eventName, true, true, data)
  el.dispatchEvent(event)
}

function initMask(el, opts) {
  el.maskRef = IMask(el, opts).on('accept', () => {
    fireEvent(el, 'accept', el.maskRef)
  })
  .on('complete', () => {
    fireEvent(el, 'complete', el.maskRef)
  })
}

function destroyMask(el) {
  if(el.maskRef) {
    el.maskRef.destroy()
    delete el.maskRef
  }
}
